export const srmOptions = [
    {
        label: 'Light (<5)',
        value: '0,5',
    },
    {
        label: 'Gold (6-9)',
        value: '6,9',
    },
    {
        label: 'Amber (10-18)',
        value: '10,18',
    },
    {
        label: 'Brown (19-29)',
        value: '19,29',
    },
    {
        label: 'Dark Brown (30-37)',
        value: '30,37',
    },
    {
        label: 'Black (>38)',
        value: '38,100',
    },
]
